import { render, staticRenderFns } from "./GridCardField.vue?vue&type=template&id=2ede5e70&scoped=true"
import script from "./GridCardField.vue?vue&type=script&lang=js"
export * from "./GridCardField.vue?vue&type=script&lang=js"
import style0 from "./GridCardField.vue?vue&type=style&index=0&id=2ede5e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ede5e70",
  null
  
)

export default component.exports